export enum LanguageCode {
    AA = 'aa',
    AB = 'ab',
    AE = 'ae',
    AF = 'af',
    AK = 'ak',
    AM = 'am',
    AN = 'an',
    AR = 'ar',
    AR_AE = 'ar-ae',
    AR_BH = 'ar-bh',
    AR_DZ = 'ar-dz',
    AR_EG = 'ar-eg',
    AR_IQ = 'ar-iq',
    AR_JO = 'ar-jo',
    AR_KW = 'ar-kw',
    AR_LB = 'ar-lb',
    AR_LY = 'ar-ly',
    AR_MA = 'ar-ma',
    AR_OM = 'ar-om',
    AR_QA = 'ar-qa',
    AR_SA = 'ar-sa',
    AR_SY = 'ar-sy',
    AR_TN = 'ar-tn',
    AR_YE = 'ar-ye',
    AS = 'as',
    AV = 'av',
    AY = 'ay',
    AZ = 'az',
    BA = 'ba',
    BE = 'be',
    BG = 'bg',
    BH = 'bh',
    BI = 'bi',
    BM = 'bm',
    BN = 'bn',
    BO = 'bo',
    BR = 'br',
    BS = 'bs',
    CA = 'ca',
    CE = 'ce',
    CH = 'ch',
    CO = 'co',
    CR = 'cr',
    CS = 'cs',
    CU = 'cu',
    CV = 'cv',
    CY = 'cy',
    DA = 'da',
    DE = 'de',
    DE_AT = 'de-at',
    DE_CH = 'de-ch',
    DE_DE = 'de-de',
    DE_LI = 'de-li',
    DE_LU = 'de-lu',
    DIV = 'div',
    DV = 'dv',
    DZ = 'dz',
    EE = 'ee',
    EL = 'el',
    EN = 'en',
    EN_AU = 'en-au',
    EN_BZ = 'en-bz',
    EN_CA = 'en-ca',
    EN_CB = 'en-cb',
    EN_GB = 'en-gb',
    EN_IE = 'en-ie',
    EN_JM = 'en-jm',
    EN_NZ = 'en-nz',
    EN_PH = 'en-ph',
    EN_TT = 'en-tt',
    EN_US = 'en-us',
    EN_ZA = 'en-za',
    EN_ZW = 'en-zw',
    EO = 'eo',
    ES = 'es',
    ES_AR = 'es-ar',
    ES_BO = 'es-bo',
    ES_CL = 'es-cl',
    ES_CO = 'es-co',
    ES_CR = 'es-cr',
    ES_DO = 'es-do',
    ES_EC = 'es-ec',
    ES_ES = 'es-es',
    ES_GT = 'es-gt',
    ES_HN = 'es-hn',
    ES_MX = 'es-mx',
    ES_NI = 'es-ni',
    ES_PA = 'es-pa',
    ES_PE = 'es-pe',
    ES_PR = 'es-pr',
    ES_PY = 'es-py',
    ES_SV = 'es-sv',
    ES_US = 'es-us',
    ES_UY = 'es-uy',
    ES_VE = 'es-ve',
    ET = 'et',
    EU = 'eu',
    FA = 'fa',
    FF = 'ff',
    FI = 'fi',
    FJ = 'fj',
    FO = 'fo',
    FR = 'fr',
    FR_BE = 'fr-be',
    FR_CA = 'fr-ca',
    FR_CH = 'fr-ch',
    FR_FR = 'fr-fr',
    FR_LU = 'fr-lu',
    FR_MC = 'fr-mc',
    FY = 'fy',
    GA = 'ga',
    GD = 'gd',
    GL = 'gl',
    GN = 'gn',
    GU = 'gu',
    GV = 'gv',
    HA = 'ha',
    HE = 'he',
    HI = 'hi',
    HO = 'ho',
    HR = 'hr',
    HR_BA = 'hr-ba',
    HR_HR = 'hr-hr',
    HT = 'ht',
    HU = 'hu',
    HY = 'hy',
    HZ = 'hz',
    IA = 'ia',
    ID = 'id',
    IE = 'ie',
    IG = 'ig',
    II = 'ii',
    IK = 'ik',
    IN = 'in',
    IO = 'io',
    IS = 'is',
    IT = 'it',
    IT_CH = 'it-ch',
    IT_IT = 'it-it',
    IU = 'iu',
    IW = 'iw',
    JA = 'ja',
    JI = 'ji',
    JV = 'jv',
    JW = 'jw',
    KA = 'ka',
    KG = 'kg',
    KI = 'ki',
    KJ = 'kj',
    KK = 'kk',
    KL = 'kl',
    KM = 'km',
    KN = 'kn',
    KO = 'ko',
    KOK = 'kok',
    KR = 'kr',
    KS = 'ks',
    KU = 'ku',
    KV = 'kv',
    KW = 'kw',
    KY = 'ky',
    KZ = 'kz',
    LA = 'la',
    LB = 'lb',
    LG = 'lg',
    LI = 'li',
    LN = 'ln',
    LO = 'lo',
    LS = 'ls',
    LT = 'lt',
    LU = 'lu',
    LV = 'lv',
    MG = 'mg',
    MH = 'mh',
    MI = 'mi',
    MK = 'mk',
    ML = 'ml',
    MN = 'mn',
    MO = 'mo',
    MR = 'mr',
    MS = 'ms',
    MS_BN = 'ms-bn',
    MS_MY = 'ms-my',
    MT = 'mt',
    MY = 'my',
    NA = 'na',
    NB = 'nb',
    ND = 'nd',
    NE = 'ne',
    NG = 'ng',
    NL = 'nl',
    NL_BE = 'nl-be',
    NL_NL = 'nl-nl',
    NN = 'nn',
    NO = 'no',
    NR = 'nr',
    NS = 'ns',
    NV = 'nv',
    NY = 'ny',
    OC = 'oc',
    OJ = 'oj',
    OM = 'om',
    OR = 'or',
    OS = 'os',
    PA = 'pa',
    PI = 'pi',
    PL = 'pl',
    PS = 'ps',
    PT = 'pt',
    PT_BR = 'pt-br',
    PT_PT = 'pt-pt',
    QU = 'qu',
    QU_BO = 'qu-bo',
    QU_EC = 'qu-ec',
    QU_PE = 'qu-pe',
    RM = 'rm',
    RN = 'rn',
    RO = 'ro',
    RU = 'ru',
    RW = 'rw',
    SA = 'sa',
    SB = 'sb',
    SC = 'sc',
    SD = 'sd',
    SE = 'se',
    SE_FI = 'se-fi',
    SE_NO = 'se-no',
    SE_SE = 'se-se',
    SG = 'sg',
    SH = 'sh',
    SI = 'si',
    SK = 'sk',
    SL = 'sl',
    SM = 'sm',
    SN = 'sn',
    SO = 'so',
    SQ = 'sq',
    SR = 'sr',
    SR_BA = 'sr-ba',
    SR_SP = 'sr-sp',
    SS = 'ss',
    ST = 'st',
    SU = 'su',
    SV = 'sv',
    SV_FI = 'sv-fi',
    SV_SE = 'sv-se',
    SW = 'sw',
    SX = 'sx',
    SYR = 'syr',
    TA = 'ta',
    TE = 'te',
    TG = 'tg',
    TH = 'th',
    TI = 'ti',
    TK = 'tk',
    TL = 'tl',
    TN = 'tn',
    TO = 'to',
    TR = 'tr',
    TS = 'ts',
    TT = 'tt',
    TW = 'tw',
    TY = 'ty',
    UG = 'ug',
    UK = 'uk',
    UR = 'ur',
    US = 'us',
    UZ = 'uz',
    VE = 've',
    VI = 'vi',
    VO = 'vo',
    WA = 'wa',
    WO = 'wo',
    XH = 'xh',
    YI = 'yi',
    YO = 'yo',
    ZA = 'za',
    ZH = 'zh',
    ZH_CN = 'zh-cn',
    ZH_HK = 'zh-hk',
    ZH_MO = 'zh-mo',
    ZH_SG = 'zh-sg',
    ZH_TW = 'zh-tw',
    ZU = 'zu'
}
